"use client";

import { create } from "zustand";

interface UiState {
  palette: boolean;
  shortcuts: boolean;
  encerrar: boolean;
  setPalette: (v: boolean) => void;
  setShortcuts: (v: boolean) => void;
  setEncerrar: (v: boolean) => void;
}

export const useUi = create<UiState>((set) => ({
  palette: false,
  shortcuts: false,
  encerrar: false,
  setPalette: (palette) => set({ palette }),
  setShortcuts: (shortcuts) => set({ shortcuts }),
  setEncerrar: (encerrar) => set({ encerrar }),
}));
